import React from 'react';
import s from './Modal.module.css';
import { ReactComponent as CloseIcon } from '../../icons/close_button.svg';

export function Modal({
  title,
  onClose,
  children,
  onCancel,
  onSubmit,
  cancelLabel = 'Отменить',
  submitLabel = 'Создать',
  cancelDisabled = false,
  submitDisabled = false,
  submitType = 'button',
  formId,
  closeOnBackdrop = true,
  footer,
  className = '',
  cardClassName = '',
  bodyClassName = '',
}) {
  const showCancel = typeof onCancel === 'function';

  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (!closeOnBackdrop) return;
    if (e.target === e.currentTarget) onClose?.();
  };

  const footerClass = `${s.footer} ${!showCancel ? s.footerSingle : ''}`.trim();

  return (
    <div
      role="dialog"
      aria-modal="true"
      className={`${s.backdrop} ${className}`.trim()}
      onClick={handleBackdropClick}
    >
      <div className={`${s.card} ${cardClassName}`.trim()} onClick={(e) => e.stopPropagation()}>
        <div className={s.header}>
          <strong>{title}</strong>
          <button
            type="button"
            onClick={onClose}
            className={s.closeBtn}
            aria-label="Закрыть"
          >
            <CloseIcon className={s.closeIcon} />
          </button>
        </div>

        <div className={`${s.body} ${bodyClassName}`.trim()}>
          {children}
        </div>

        {footer ?? (
          <div className={footerClass}>
            {showCancel && (
              <button type="button" className={s.btnCancel} onClick={onCancel} disabled={cancelDisabled}>
                {cancelLabel}
              </button>
            )}
            <button
              type={submitType}
              form={formId}
              className={s.btnPrimary}
              disabled={submitDisabled}
              onClick={submitType === 'button' ? onSubmit : undefined}
            >
              {submitLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
